export default "__VITE_ASSET__baee0a7e__"